import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import "../Print.css";

type SalesDataProps = {
  salesData: Array<object>;
};

export const SalesSummary: FunctionComponent<SalesDataProps> = (salesData: {
  [key: string]: any;
}) => {
  // const creditSalesTotal = 0;
  // const sum =
  //   parseFloat(salesData.salesData.total_cash_receive) +
  //   parseFloat(salesData.salesData.total_customercredit_amount);
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "35%" }}
                >
                  {" "}
                  Type
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.headColor}
                  // style={{ width: "25%" }}
                >
                  Number of Transaction
                </TableCell>
                {/* <TableCell align="center" className={classes.headColor}>
                  Sales Amount
                </TableCell>
                <TableCell align="center" className={classes.columnWeight}>
                  Discount Amount
                </TableCell> */}
                <TableCell align="right" className={classes.headColor}>
                  Total Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Cash Sales
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.total_cash_receive_count}
                </TableCell>
                {/* <TableCell
                  align="left"
                  className={classes.tablecontentSalesandCard}
                >
                  {salesData.salesData.total_cash_receive}
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.cash_disc_amount_total}
                </TableCell> */}
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.total_cash_receive}
                </TableCell>
              </TableRow>
              <TableRow
                style={{
                  display:
                    salesData.salesData.credit_card_total_count !== 0
                      ? ""
                      : "none",
                }}
              >
                <TableCell align="left" className={classes.headColor}>
                  Credit Card Sales
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.credit_card_total_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.credit_card_total}
                </TableCell>
              </TableRow>
              <TableRow
                style={{
                  display:
                    salesData.salesData.foreign_currency_total_count !== 0
                      ? ""
                      : "none",
                }}
              >
                <TableCell align="left" className={classes.headColor}>
                  Foreign Currency Sales
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.foreign_currency_total_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.local_foreign_currency_total}
                </TableCell>
              </TableRow>
              <TableRow
                style={{
                  display:
                    salesData.salesData.total_customercredit_count !== 0
                      ? ""
                      : "none",
                }}
              >
                <TableCell align="left" className={classes.headColor}>
                  Credit Sales
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.total_customercredit_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.total_customercredit_amount}
                </TableCell>
              </TableRow>
              <TableRow
                style={{
                  display:
                    salesData.salesData.voucher_total_count !== 0 ? "" : "none",
                }}
              >
                <TableCell align="left" className={classes.headColor}>
                  Voucher Total
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.voucher_total_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.voucher_total_amount}
                </TableCell>
              </TableRow>

              <TableRow
                style={{
                  display:
                    salesData.salesData.loyalityPoint_total_count !== 0
                      ? ""
                      : "none",
                }}
              >
                <TableCell align="left" className={classes.headColor}>
                  Loyalty Total
                </TableCell>
                <TableCell align="left" className={classes.tableColumn}>
                  {salesData.salesData.loyalityPoint_total_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {salesData.salesData.loyalityPoint_total_amount}
                </TableCell>
              </TableRow>

              <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Total</Typography>
                </TableCell>
                <TableCell align="left" className={classes.middleTotalcell} />
                <TableCell align="right" className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {salesData.salesData.bill_net_total}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>Total</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>
              {salesData.salesData.bill_net_total}
            </Typography>
          </Grid>
        </Grid> */}
      {/* </Grid> */}
    </Grid>
  );
};
{
  /* <Grid item xs ={12}>
                   <Grid container>
                       <Grid item xs={6} >
                           <Typography className={classes.total}>Total</Typography>
                       </Grid>
                       <Grid item xs= {6} >
                           <Typography className={classes.value}>{sum}</Typography>
                       </Grid>
                   </Grid>
               </Grid> */
}
